import { useMemo } from 'react';

import type { DivisionResponse } from '../types/api/response/division';
import useCompanyInfo, { makeFullDataDivisions } from './useCompanyInfo';

export default function useFetchDivisions({
  companyId,
}: {
  companyId: string;
}) {
  const { data, refetch, isLoading, isError } = useCompanyInfo(companyId);

  const divisions: DivisionResponse[] = useMemo(
    () => makeFullDataDivisions(data),
    [data]
  );

  return {
    divisions,
    refetch,
    isLoading,
    isError,
  };
}
